/*jshint esversion: 6 */
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';
import dialogPolyfill from "dialog-polyfill";

// handle the forms interactive elements and form submit

let WidgetJournalRatingForm = function (config) {

    let getJournalArticleId = function(articleIdSelector) {
        let articleIdElement = document.querySelector(articleIdSelector)
        if (articleIdElement) {
            return articleIdElement.getAttribute('data-id');
        }
        return null;
    }

    // default values for config argument
    let articleId = getJournalArticleId('#btn-cite-show');
    config.route = (typeof config.route !== 'undefined') ? config.route : '/widget/journal/%id%/rating';
    config.id = (typeof config.id !== 'undefined') ? config.id : articleId;
    config.modalSelector = (typeof config.id !== 'undefined') ? config.modalSelector : '';

    let questionContainers = document.getElementsByClassName('video-rating-question-container');

    const modalElement = document.querySelector(config.modalSelector);
    if (modalElement) {
        dialogPolyfill.registerDialog(modalElement);
    }

    let buildForm = function (id) {
        config.id = id;
        for (let i = 0; i < questionContainers.length; i++) {

            let questionID = questionContainers[i].getAttribute('data-question');
            let hiddenInput = questionContainers[i].getElementsByTagName('input')[0];
            let buttons = questionContainers[i].getElementsByTagName('button');

            for (let i = 0; i < buttons.length; i++) {
                let button = buttons[i];
                button.onclick = function () {

                    let stars = button.getAttribute('value');
                    console.log('You gave question ' + questionID + ' ' + stars + ' stars');
                    hiddenInput.value = stars;

                    populateStorage();

                    for (let y = 0; y < buttons.length; y++) {
                        buttons[y].classList.remove('star-rating-checked');
                        if (i >= y) {
                            buttons[y].classList.add('star-rating-checked');
                        }
                    }

                    return false;
                };

                // the following two listeners highlight all stars upto and including the one hovered over
                button.addEventListener('mouseenter',function () {

                    for (let y = 0; y < buttons.length; y++) {
                        if (i >= y) {
                            buttons[y].classList.add('star-rating-checked-temporary');
                        }
                    }

                    return false;
                });
                button.addEventListener('mouseleave',function () {

                    for (let y = 0; y < buttons.length; y++) {
                        buttons[y].classList.remove('star-rating-checked-temporary');
                    }

                    return false;
                });
            }

        }

        setDisplayRatingsFromStorage();

        openDialog();
    };

    let populateStorage = function () {
        let questions = Object.create(null);

        for (let i = 0; i < questionContainers.length; i++) {
            let questionID = questionContainers[i].getAttribute('data-question');
            let hiddenInput = questionContainers[i].getElementsByTagName('input')[0];

            questions[questionID] = hiddenInput.value;
        }

        localStorage.setItem('article.'+articleId, JSON.stringify(questions));
    };

    let setDisplayRatingsFromStorage = function (overwriteForm = false) {
        let currentQuestions = JSON.parse(localStorage.getItem('article.'+articleId));

        for (let i = 0; i < questionContainers.length; i++) {
            let questionID = questionContainers[i].getAttribute('data-question');
            let hiddenInput = questionContainers[i].getElementsByTagName('input')[0];
            let buttons = questionContainers[i].getElementsByTagName('button');

            let rating = hiddenInput.value;
            if (rating !== '0' && overwriteForm === false) {
                continue;
            }

            // Use localstorage rating
            if (currentQuestions) {
                let storedRating = currentQuestions[questionID];
                if (storedRating) {
                    hiddenInput.value = rating = storedRating;

                    for (let i = 0; i < buttons.length; i++) {
                        buttons[i].classList.remove('star-rating-checked');
                        if (rating > i) {
                            buttons[i].classList.add('star-rating-checked');
                        }
                    }
                }
            }
        }
    }

    /**
     * Create the route string
     *
     * @param id
     *
     * @returns {string}
     */
    let createRoute = function (id) {
        return Utils.generateRouteFromPattern({
            pattern: {
                '%id%': id
            },
            route: config.route,
            env: config.env,
            locale: config.locale
        });
    };

    let sendRequest = function (payload) {
        let route = createRoute(config.id);
        Ajax.postRequest(route, payload, function () {
            Utils.displayAlert('Thank you for rating the article', 'success');
        }, function () {
            Utils.displayAlert('Please try again', 'error');
        })
    };

    let submitForm = function () {
        let form = document.forms["journal-rating"];
        let sendData = true;
        let payload = {
            'rating': []
        };

        for (let x = 1; x <= 3; x++) {
            let element_name = "question_" + x;
            let element = form[element_name];
            let questionID = form[element_name].getAttribute('data-question-id');

            if (element.value === 0 || element.value === "" || element.value === "0") {
                sendData = false;
                break;
            } else {
                payload.rating.push({
                    'id': questionID,
                    'value': element.value
                });
            }
        }

        if (sendData) {
            // Send AJAX request
            sendRequest(payload);
        }

        closeDialog();
    };

    let openDialog = function () {
        let dialog = getDialog();
        dialog.show();

        // handle bootstrap modals too
        if (dialog.parentElement.classList.contains("modal")) {
            let element = $('#' + dialog.parentElement.id);
            if (element) {
                element.modal('show');
            }
        }
    };

    let closeDialog = function () {
        let dialog = getDialog();
        dialog.close();

        // handle bootstrap modals too
        if (dialog.parentElement.classList.contains("modal")) {
            $('#'+dialog.parentElement.id).modal('hide');
        }
    };

    let getDialog = function () {
        return modalElement;
    };


    return {
        buildForm: buildForm,
        submitForm: submitForm,
        openDialog: openDialog,
        closeDialog: closeDialog,
        getJournalArticleId : getJournalArticleId
    };

};

export default WidgetJournalRatingForm;